import { NgModule, LOCALE_ID } from '@angular/core';
import { CommonModule, registerLocaleData } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import localePT from '@angular/common/locales/pt';
import localeExtraPT from '@angular/common/locales/extra/pt';


import { TooltipModule } from 'primeng/tooltip';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { RatingModule } from 'primeng/rating';
import { InputTextModule } from 'primeng/inputtext';
import { ToolbarModule } from 'primeng/toolbar';
import { FileUploadModule } from 'primeng/fileupload';
import { DialogModule } from 'primeng/dialog';
 import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { RadioButtonModule } from 'primeng/radiobutton';
import { InputNumberModule } from 'primeng/inputnumber';
import {DividerModule} from 'primeng/divider';
import {TabViewModule} from 'primeng/tabview';
import {TimelineModule} from 'primeng/timeline';
import {ScrollPanelModule} from 'primeng/scrollpanel';
import {ListboxModule} from 'primeng/listbox';
import {GMapModule} from 'primeng/gmap';
import {SelectButtonModule} from 'primeng/selectbutton';
import { DropdownModule } from 'primeng/dropdown';
import {CheckboxModule} from 'primeng/checkbox';



import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastModule } from 'primeng/toast';
import { SharedModule } from 'src/app/shared/shared.module';
import { PaginatorModule } from 'primeng/paginator';
import { DirectivesModule } from 'src/app/shared/directives/directives.module';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';
import { AtributoComponent } from './atributo/atributo.component';



registerLocaleData(localePT, 'pt', localeExtraPT);


@NgModule({
  declarations: [AtributoComponent],
  providers: [{provide: LOCALE_ID, useValue: 'pt'}],
  imports: [
    PipesModule,
    TooltipModule,
    CommonModule,
    FormsModule,
    TableModule,    
    ButtonModule,
    RatingModule,
    InputTextModule,
    ToolbarModule,
    FileUploadModule,
    DialogModule,
    RouterModule,
    ConfirmDialogModule,
    RadioButtonModule,
    InputTextModule,
    InputNumberModule,    
    BrowserModule,
    DividerModule,
    TabViewModule,
    TimelineModule,
    ScrollPanelModule,
    ListboxModule,
    GMapModule,
    SelectButtonModule,
    DropdownModule,
    CheckboxModule,
    SharedModule,
    ToastModule,
    BrowserAnimationsModule,
    PaginatorModule,
    DirectivesModule
    
  ],
  exports: [AtributoComponent],
  
})
export class PessoaModule { }